/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Release_AInputs */

const en_mk_tb_faq_release_a = /** @type {(inputs: Mk_Tb_Faq_Release_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Evidence, human acceptance and release are tracked separately. The owner can record a deployment that has already completed. The record stores its revision and destination; it does not run deployment. Tasks with only manual criteria can receive independent human review without being labeled test-verified.`)
};

const id_mk_tb_faq_release_a = /** @type {(inputs: Mk_Tb_Faq_Release_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Bukti, penerimaan manusia, dan rilis dicatat terpisah. Pemilik dapat mencatat deployment yang sudah selesai. Catatan menyimpan revisi dan tujuannya; catatan itu tidak menjalankan deployment. Tugas dengan kriteria manual saja dapat ditinjau manusia secara independen tanpa diberi label tes terverifikasi.`)
};

/**
* | output |
* | --- |
* | "No. Evidence, human acceptance and release are tracked separately. The owner can record a deployment that has already completed. The record stores its revisi..." |
*
* @param {Mk_Tb_Faq_Release_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_release_a = /** @type {((inputs?: Mk_Tb_Faq_Release_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Release_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_release_a(inputs)
	return en_mk_tb_faq_release_a(inputs)
});